import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Map from 'pigeon-maps';
import Pin from './Pin';
import User from './User';

import './App.css';
import logo from './logo.svg';

class App extends React.Component {
  constructor() {
    super()
    this.state = {
      lat: 0,
      long: 0,
      userPosition: {
        lat: 0,
        long: 0,
      },
      accuracy: 0,
      getUserLocation: false,
      pins: [
        {
          id: 0,
          lat: 49.087707,
          long: 2.505758,
          infos: {
            name: 'Skatepark de marly-la-ville',
            condition: 5
          }
        },
        {
          id: 1,
          lat: 49.087965,
          long: 2.559108,
          infos: {
            name: 'Skatepark de Saint Witz',
            condition: 5
          }
        },
        {
          id: 2,
          lat: 49.0330887,
          long: 2.4817129,
          infos: {
            name: 'Skatepark de Goussainville',
            condition: 3,
          }
        },
        {
          id: 3,
          lat: 49.0511821,
          long: 2.5099468,
          infos: {
            name: 'Skatepark de Louvres',
            condition: 2,
          }
        },
        {
          id: 4,
          lat: 48.8301638,
          long: 2.5244394,
          infos: {
            name: 'Skatepark de Brie sur Marne',
            condition: 5,
          }
        }
      ]
    }
  }

  render() {

    const latitude = this.state.lat;
    const longitude = this.state.long;
    const userLat = this.state.userPosition.lat;
    const userLong = this.state.userPosition.long;
    const accuracy = this.state.accuracy;
    const { pins } = this.state;
    const { getUserLocation } = this.state;

    let currentState = this;

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    function success(pos) {
      console.info("I'm watching your position");
      const crd = pos.coords;
      if(!getUserLocation) {
        currentState.setState(
          {
            lat: crd.latitude,
            long: crd.longitude,
            accuracy: crd.accuracy,
            getUserLocation: true,
            userPosition: {
              lat: crd.latitude,
              long: crd.longitude, 
            }
          }
        )
      } else {
        currentState.setState(
          {
            userPosition: {
              lat: crd.latitude,
              long: crd.longitude, 
            }
          }
        )
      }
    }

    function error(err) {
      console.warn(`ERREUR (${err.code}): ${err.message}`);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);

    // compute the distance in meters or kilometers between two POI.
    const getDistanceBetween = (userLat, userLong, pinLat, pinLong) => {
      const Radius = 6371; // for km (change this const to get miles)
      const distanceLat = (userLat - pinLat) * Math.PI / 180;
      const distanceLong = (userLong - pinLong) * Math.PI / 180;
      const a = Math.sin(distanceLat / 2) * Math.sin(distanceLat / 2) +
        Math.cos(userLat * Math.PI / 180) * Math.cos(pinLat * Math.PI / 180) *
        Math.sin(distanceLong / 2) * Math.sin(distanceLong / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = Radius * c;
      if (distance > 1) return Math.round(distance) + "km";
      else if (distance <= 1) return Math.round(distance * 1000) + "m";
      return distance;
    }
    //
    const providers = {
      osm: (x, y, z) => {
        const s = String.fromCharCode(97 + (x + y + z) % 3)
        return `https://${s}.tile.openstreetmap.org/${z}/${x}/${y}.png`
      },
      wikimedia: (x, y, z, dpr) => {
        return `https://maps.wikimedia.org/osm-intl/${z}/${x}/${y}${dpr >= 2 ? '@2x' : ''}.png`
      },
      stamen: (x, y, z, dpr) => {
        return `https://stamen-tiles.a.ssl.fastly.net/terrain/${z}/${x}/${y}${dpr >= 2 ? '@2x' : ''}.jpg`
      },
      watercolor: (x, y, z) => {
        return `http://c.tile.stamen.com/watercolor/${z}/${x}/${y}.jpg`
      },
      light: (x, y, z) => {
        return `http://a.tile.stamen.com/toner/${z}/${x}/${y}.png`
      }
    }

    return (
      <div className="App">
        <header>
          <h1><img className='header-logo' src={logo} alt="logo skateparks map" /> Skateparks-map</h1>
        </header>
        <Map center={[latitude, longitude]} zoom={14} provider={providers['osm']} onclick={(e) => { console.log('coucou') }}>
        <User
            anchor={[userLat, userLong]}
            offset={[8, 8]}
            id="me"
          />
          {pins.map((pin, index) => (
            <Pin
              distance={getDistanceBetween(latitude, longitude, pin.lat, pin.long)}
              key={index}
              anchor={[pin.lat, pin.long]}
              offset={[12, 34]}
              infos={pin.infos}
              id={index}
            />
          ))}
        </Map>
        <footer>
          <small title={`lat:${userLat} long:${userLong} acc:${accuracy} meters.`}>Beta V:0.0.3</small>
        </footer>
      </div>
    )
  }
}

export default App;
